import { render, staticRenderFns } from "./CheckoutItemList.vue?vue&type=template&id=5d1c38c2&scoped=true&"
import script from "./CheckoutItemList.vue?vue&type=script&lang=js&"
export * from "./CheckoutItemList.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutItemList.vue?vue&type=style&index=0&id=5d1c38c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c38c2",
  null
  
)

export default component.exports